import { defineStore } from 'pinia';
import { ElNotification } from 'element-plus';

function isOnAccessDeniedRoute(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.endsWith('/acces-refuse');
}

export enum TypeNotification {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error',
}

export type globalState = {
  globalLoaders: Array<boolean>;
};

export const useGlobalStore = defineStore('globalStore', {
  state: () =>
    ({
      globalLoaders: [],
    } as globalState),
  actions: {
    addGlobalLoader() {
      this.globalLoaders = [...this.globalLoaders, true];
    },
    removeOneGlobalLoader() {
      if (this.globalLoaders.length > 0) {
        setTimeout(() => {
          this.globalLoaders = this.globalLoaders.filter(
            (el, i) => i !== this.globalLoaders.length - 1
          );
        }, 1000);
      }
    },
    clearGlobalLoaders() {
      this.globalLoaders = [];
    },

    showNotification(
      typeAlert: TypeNotification = TypeNotification.ERROR,
      message?: string,
      title?: string,
      duration: number = 4500
    ) {
      if (
        typeAlert === TypeNotification.ERROR &&
        isOnAccessDeniedRoute()
      ) {
        return;
      }
      ElNotification({
        title: title,
        message: message,
        type: typeAlert,
        duration: duration,
      });
    },
  },
  getters: {
    getIsGlobalLoaderOn: state => state.globalLoaders.length > 0,
  },
});
